/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-const */
/* eslint-disable comma-spacing */
/* eslint-disable quotes */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import 'antd/dist/antd.dark.css';
import { Table, Tabs, notification, Button, Spin } from 'antd';
import { useHistory } from 'react-router-dom';
import Admin from './asset-management';
import Spares from './spares-managment';
import { authenticateCurrentUser } from '../../services/auth';
import ToolboxAdmin from '../../components/ToolboxAdmin';
import AdminEmployees from '../../components/AdminEmployees';
import EquipmentSubCategory from './EquipmentSubCategory';
import DocControlMangement from '../../components/Calibration/DocControlMangement';
import ShippingManagement from '../../components/ShippingManagement/ShippingManagement';
import AdminReportingEmailPage from '../../components/AdminReportingEmailPage';
import UserManagementAGGrid from '../userManagement/UserManagementAGGrid';
import { EyeOutlined } from '@ant-design/icons';
import * as ConsumableMaterialAdminModule from '../../components/admin/ConsumableMaterialAdmin';

const { TabPane } = Tabs;

const AdminPage = () => {
  const history = useHistory();
  const [group, setGroup] = useState(false);
  const [currentSection, setCurrentSection] = useState('type');

  useEffect(() => {
    authenticateCurrentUser()
      .then((data) => {
        if (
          data.signInUserSession.accessToken.payload['cognito:groups'] &&
          data.signInUserSession.accessToken.payload['cognito:groups'].includes('crc-admin')
        ) {
          setGroup(true);
        } else {
          // notification.info({
          //   message: 'User created successfully. You are not added to any group. Please contact Vinay.Baburao@sbdinc.com.'
          // });
          setGroup(false);
        }
      })
      .catch((error) => {
        setGroup(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (key) => {
    const tabRoutes = {
      '2': '/admin/user-management',
      '3': '/admin/communications',
      '4': '/admin/spares',
      '5': '/admin/employees',
      '6': '/admin/documentation',
      '7': '/admin/calibration-control-users',
      '10': '/admin/shipping-management',
      '11': '/admin/reporting-email',
    };

    if (tabRoutes[key]) {
      window.open(tabRoutes[key], '_blank');
    }
  };

  return (
    <div className="h-100 d-flex flex-column">
      <div className="flex-auto">
        <Tabs
          className="custom-tab h-100"
          onChange={onChange}
        >
          <TabPane
            tab="Asset Management"
            key="1"
          >
            <Admin />
          </TabPane>
          <TabPane
            tab="Shipping Management"
            key="10"
          >
            <div className="d-flex justify-content-center align-items-center h-100 mt-5">
              <Spin size="large" />
              <span className="ms-3">Opening Shipping Management...</span>
            </div>
          </TabPane>

          <TabPane
            tab="User Management"
            key="2"
          >
            <div className="d-flex justify-content-center align-items-center h-100 mt-5">
              <Spin size="large" />
              <span className="ms-3">Opening User Management...</span>
            </div>
          </TabPane>
          <TabPane
            tab="Reporting Email"
            key="11"
          >
            <div className="d-flex justify-content-center align-items-center h-100 mt-5">
              <Spin size="large" />
              <span className="ms-3">Opening Reporting Email...</span>
            </div>
          </TabPane>
          <TabPane
            tab="Communications"
            key="3"
          >
            <div className="d-flex justify-content-center align-items-center h-100 mt-5">
              <Spin size="large" />
              <span className="ms-3">Opening Communications...</span>
            </div>
          </TabPane>
          <TabPane
            tab="Spares"
            key="4"
          >
            <div className="d-flex justify-content-center align-items-center h-100 mt-5">
              <Spin size="large" />
              <span className="ms-3">Opening Spares...</span>
            </div>
          </TabPane>
          <TabPane
            tab="Employees"
            key="5"
          >
            <div className="d-flex justify-content-center align-items-center h-100 mt-5">
              <Spin size="large" />
              <span className="ms-3">Opening Employees...</span>
            </div>
          </TabPane>
          <TabPane
            tab="Documentation"
            key="6"
          >
            <div className="d-flex justify-content-center align-items-center h-100 mt-5">
              <Spin size="large" />
              <span className="ms-3">Opening Documentation...</span>
            </div>
          </TabPane>

          <TabPane
            tab="Consumable "
            key="8"
          >
            <ConsumableMaterialAdminModule.ConsumableMasterAdmin />
          </TabPane>

          <TabPane
            tab="Material"
            key="9"
          >
            <ConsumableMaterialAdminModule.MaterialMasterAdmin />
          </TabPane>

          <TabPane
            tab="Calibration & Control"
            key="7"
          >
            <div className="d-flex justify-content-center align-items-center h-100 mt-5">
              <Spin size="large" />
              <span className="ms-3">Opening Calibration & Control...</span>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default AdminPage;
